var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-51.943%",
    y1: "19.883%",
    x2: "100%",
    y2: "74.562%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#223DFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC1AFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    opacity: 0.2,
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.588 11.397V2.804L10.338 2l-4.56 1.96v1.516l-2.52.845v5.076H3V12h.823V6.673l3.342-1.055V12H9.48v-.653h-.515v-5.83l-1.213-.703-1.358.455v-.958l3.291-1.407V12H12v-.604h-.412ZM4.234 8.03l2.417-.754V6.271l-2.417.804v.955Zm0 1.307 2.417-.503V7.829l-2.417.603v.905Zm0 1.356 2.417-.301V9.387l-2.417.351v.955Zm0 1.307 2.417-.05v-1.006l-2.417.101V12Z",
    fill: "#B41CFF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.21235c0a56383dd1a07800fdc4fd801f.svg";
export { ForwardRef as ReactComponent };